module.exports = __webpack_public_path__ + "static/media/star-md.684ec86a.png";